import { formatBusinessDateTimeFromIso } from '@nudool/shared';
import { RotateCcwClockIcon } from 'lucide-react';

import { cn } from './lib/utils.js';

export type DimeLastUpdatedProps = {
  date: string | null | undefined;
  updatedBy?: string | null;
  size?: 'xs' | 'sm';
  className?: string;
};

export function DimeLastUpdated({ date, updatedBy, size = 'sm', className }: DimeLastUpdatedProps) {
  const formatted = formatBusinessDateTimeFromIso(date);
  if (!formatted) return null;

  const summary = updatedBy ? `Updated ${formatted} by ${updatedBy}` : `Updated ${formatted}`;

  return (
    <p
      className={cn(
        'flex items-center gap-1.5 text-muted-foreground',
        size === 'xs' ? 'text-xs' : 'text-sm',
        className,
      )}
    >
      <RotateCcwClockIcon
        aria-hidden
        className={cn('shrink-0', size === 'xs' ? 'size-3' : 'size-3.5')}
      />
      <span>{summary}</span>
    </p>
  );
}
